import { createContext } from "react"

const ContractorClassificationsContext = createContext();

export default ContractorClassificationsContext;